import {
  AiFillHeart,
  AiOutlineHeart,
  AiOutlineComment,
  AiOutlineShareAlt,
  AiOutlinePlayCircle,
} from "react-icons/ai";
import { FaUserPlus, FaUserCheck, FaRegComment } from "react-icons/fa";
import { BsBookmark, BsBookmarkFill } from "react-icons/bs";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Box, Button, Typography, Tooltip } from "@mui/material";
import { motion } from "framer-motion";
import { useRef, useState, useEffect } from "react";
import { IoVolumeMute, IoVolumeHigh } from "react-icons/io5";
import { BiExpand, BiCollapse } from "react-icons/bi";
import CommentOverlay from "./commentOverlay/CommentOverlay";
import { v4 as uuidv4 } from "uuid";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { Chip } from "@mui/material";
import { StarRounded } from "@mui/icons-material";
// Add these imports at the top with your other imports
import { useCallback } from "react";
// Add these imports at the top of Post.jsx
import { toast } from "react-toastify";
import { FaUserClock } from "react-icons/fa";
import { Client, Databases, ID, Storage, Query } from "appwrite";
import {  } from "appwrite";
import { 
  sendFollowRequest, 
  getFollowStatus, 
  createFollowRequestNotificationSafe // Use the safe version instead
} from './appwriteFollowService';
import { CircularProgress } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';


export default function Post() {
  const [openCommentModal, setOpenCommentModal] = useState(false);
  const [liked, setLiked] = useState(false);
  const [saved, setSaved] = useState(false);
  const [followedStates, setFollowedStates] = useState({});
  const [activePostId, setActivePostId] = useState(null);
  // Replace the current filteredPosts implementation with this:
const [initialPostOrder, setInitialPostOrder] = useState([]);
  
  
  // Global user preference for audio
  const [globalMutePreference, setGlobalMutePreference] = useState(true);
  
  // Track state for each video individually
  const [videoStates, setVideoStates] = useState({});

  const navigate = useNavigate();
  const location = useLocation();
  
  const containerRef = useRef(null);
  const postsRefs = useRef({});
  const videoRefs = useRef({});
  const videoContainerRefs = useRef({});
  const progressBarRefs = useRef({});
  const userHasInteracted = useRef(false);

  const [savedStates, setSavedStates] = useState({});
  const user = useSelector((state) => state.user);
  const currentUserId = user?._id;

  // Initialize from localStorage for liked posts
  const [likedStates, setLikedStates] = useState({});
  // Replace the existing [comments, setComments] state with this
const [comments, setComments] = useState({});

const [isLoading, setIsLoading] = useState(true);
const [appwriteError, setAppwriteError] = useState(false);



// Inside your Post component, add this state
const [selectedTalent, setSelectedTalent] = useState("All");
const talents = ["All", "Singing", "Rapping", "Dancing", "Acting", "Magic", "Comedy", "Art", "Instrumental", "Photography", "Other"];
// Add this state at the top with other state declarations
const [pendingRequests, setPendingRequests] = useState({});
// Add this state at the top of your component
const [isProcessingFollow, setIsProcessingFollow] = useState(false);

const client = new Client();
client
  .setEndpoint(process.env.REACT_APP_APPWRITE_ENDPOINT)
  .setProject(process.env.REACT_APP_APPWRITE_PROJECT_ID);

const databases = new Databases(client);
const storage = new Storage(client);

// Constants
const DATABASE_ID = "681f7caf0033c79e0bc0";
const COLLECTION_ID = "681f80c000210a12ef65";
const SAVED_VIDEOS_COLLECTION_ID = "681f7f8800028b55473e";
const BUCKET_ID = process.env.REACT_APP_APPWRITE_BUCKET_ID;
const COMMENTS_COLLECTION_ID = "681f8226002842e1e80a";
const NOTIFICATION_ID = "681f845c0032fe308afb";
const FOLLOWERS_COLLECTION_ID = "681f7e8e0028ee01df31";
const FOLLOW_REQUESTS_COLLECTION_ID = "681f7d25000d9b5e446c";

// Update your fetchPostsFromAppwrite function
const fetchPostsFromAppwrite = async () => {
  try {
    setIsLoading(true);
    setAppwriteError(false);
    
    const response = await databases.listDocuments(
      DATABASE_ID,
      COLLECTION_ID,
      [Query.orderDesc('createdAt')]
    );
    
    // Transform Appwrite data to match your post structure
    const posts = response.documents.map(doc => {
      // Generate the video file URL
      const videoUrl = storage.getFileView(
        BUCKET_ID,
        doc.fileId
      );
      
      // Generate the profile image URL
      let profileImageUrl;
      if (doc.userImage && doc.userImage !== "default-profile.jpg") {
        // If userImage is an Appwrite file ID
        profileImageUrl = storage.getFileView(
          BUCKET_ID,  // Use the same bucket or specify a profile images bucket
          doc.userImage
        );
      } else {
        // Use a default image path if no userImage is provided
        profileImageUrl = "/assets/default-profile.jpg";
      }
      
      return {
        id: doc.$id,
        text: doc.description,
        video_url: videoUrl,
        talent: doc.talent,
        created_at: new Date(doc.createdAt).toLocaleDateString(),
        hashtags: doc.hashtags || [],
        likes: doc.likes || [], // Include the likes array from Appwrite
        profile: {
          user_id: doc.userId,
          name: doc.userName || "User",
          image: profileImageUrl
        }
      };
    });
    
    setIsLoading(false);
    return posts;
  } catch (error) {
    // console.error("Error fetching posts from Appwrite:", error);
    setIsLoading(false);
    setAppwriteError(true);
    return [];
  }
};
// Assuming createNotification function exists somewhere in your code:
// Update the createNotification function in Post.jsx to include profile picture path
const createNotification = async (
  receiverId,
  senderId,
  senderName,
  type,
  postId,
  content,
  senderPicturePath 
) => {
  try {
    // Create notification in Appwrite
    await databases.createDocument(
      DATABASE_ID,
      NOTIFICATION_ID,
      ID.unique(),
      {
        receiverId: receiverId,
        senderId: senderId,
        senderName: senderName,
        senderPicturePath: senderPicturePath, // Store the sender's profile picture
        type: type, // 'comment'
        postId: postId,
        content: content,
        isRead: false,
        createdAt: new Date().toISOString()
      }
    );
    
    // console.log(`Notification created for user ${receiverId} about post ${postId}`);
  } catch (error) {
    // console.error("Error creating notification:", error);
  }
};
// Function to retrieve user's notifications
const fetchUserNotifications = async (userId) => {
  try {
    const response = await databases.listDocuments(
      DATABASE_ID,
      NOTIFICATION_ID,
      [
        Query.equal('receiverId', userId),
        Query.orderDesc('createdAt'),
        Query.limit(50) // Adjust limit as needed
      ]
    );
    
    return response.documents;
  } catch (error) {
    // console.error("Error fetching notifications:", error);
    return [];
  }
};
  // Add this near the top of your Post component
useEffect(() => {
  // console.log("Current followed states:", followedStates);
}, [followedStates]);
// Add this function near the beginning of the Post component
const isOwnVideo = (post) => {
  return post.profile.user_id === currentUserId;
};



// Add this function to your Post component
// Updated function to handle declined requests as well
// Replace the checkFollowStatus function with this Appwrite implementation
const checkFollowStatus = async (userId) => {
  if (!currentUserId || !token) return;
  
  try {
    const status = await getFollowStatus(currentUserId, userId);
    
    if (status.isFollower) {
      // Request was accepted - update to "Following"
      setFollowedStates(prev => ({
        ...prev,
        [userId]: true
      }));
      
      setPendingRequests(prev => ({
        ...prev,
        [userId]: false
      }));
    } 
    else if (!status.isPending) {
      // Request was declined or removed
      setFollowedStates(prev => ({
        ...prev,
        [userId]: false
      }));
      
      setPendingRequests(prev => ({
        ...prev,
        [userId]: false
      }));
    }
  } catch (error) {
    // console.error("Error checking follow status:", error);
  }
};

// Helper function to update localStorage
const updateLocalStorage = (userId, isFollowing, isPending) => {
  // Handle followed users
  const followedUsers = JSON.parse(localStorage.getItem('followedUsers') || '[]');
  
  if (isFollowing) {
    // Add to followed if not there
    if (!followedUsers.some(follow => follow.followedId === userId && follow.followerId === currentUserId)) {
      followedUsers.push({
        followedId: userId, 
        followerId: currentUserId,
        timestamp: new Date().toISOString()
      });
    }
  } else {
    // Remove from followed
    const updatedFollowedUsers = followedUsers.filter(
      follow => !(follow.followedId === userId && follow.followerId === currentUserId)
    );
    localStorage.setItem('followedUsers', JSON.stringify(updatedFollowedUsers));
  }
  
  localStorage.setItem('followedUsers', JSON.stringify(followedUsers));
  
  // Handle pending requests
  const pendingRequests = JSON.parse(localStorage.getItem('pendingFollowRequests') || '[]');
  
  if (!isPending) {
    // Remove from pending
    const updatedPendingRequests = pendingRequests.filter(
      req => !(req.userId === userId && req.requesterId === currentUserId)
    );
    localStorage.setItem('pendingFollowRequests', JSON.stringify(updatedPendingRequests));
  }
};
// Now update the handleFollowUser function to persist to localStorage
// Update the handleFollowUser function to persist pending requests to localStorage
// Replace the handleFollowUser function with this Appwrite implementation

// Modified handleFollowUser function
const handleFollowUser = async (userId) => {
  if (!currentUserId || userId === currentUserId) return;
  
  // Prevent multiple clicks while processing
  if (isProcessingFollow) return;
  
  try {
    setIsProcessingFollow(true);
    
    // Find user details for the user being followed - needed for notification
    const targetUserResponse = await fetch(`https://my-pers-thing-server.onrender.com/users/${userId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    
    const targetUserData = await targetUserResponse.json();
    
    // Get current user details for notification
    const currentUserResponse = await fetch(`https://my-pers-thing-server.onrender.com/users/${currentUserId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    
    const currentUserData = await currentUserResponse.json();
    const currentUserName = `${currentUserData.firstName} ${currentUserData.lastName}`;
    
    // Send the follow request through Appwrite service
    const result = await sendFollowRequest(currentUserId, userId);
    
    if (result.isPending) {
      // Show pending state for follow request
      setFollowedStates(prev => ({
        ...prev,
        [userId]: false
      }));
      
      // Update button text to show pending
      setPendingRequests(prev => ({
        ...prev,
        [userId]: true
      }));
      
      // Try to create a notification but don't fail if it doesn't work
      try {
        await createFollowRequestNotificationSafe(
          userId, // receiverId (the user being followed)
          currentUserId, // senderId (current user)
          currentUserName, // sender's name
          currentUserData.picturePath // sender's profile picture
        );
      } catch (notifError) {
        // Just log the error but don't break the flow
        // console.log("Notification creation failed but follow request was sent:", notifError);
      }
      
      toast.success("Follow request sent!");
    } else if (result.isFollowing === false) {
      // Explicit unfollow action or canceled request
      setFollowedStates(prev => ({
        ...prev,
        [userId]: false
      }));
      
      setPendingRequests(prev => ({
        ...prev,
        [userId]: false
      }));
      
      toast.info("Unfollowed user");
    } else {
      // Successfully followed (should not happen with private accounts)
      setFollowedStates(prev => ({
        ...prev,
        [userId]: true
      }));
      
      setPendingRequests(prev => ({
        ...prev,
        [userId]: false
      }));
      
      toast.success("Now following user!");
    }
  } catch (error) {
    // console.error("Error following/unfollowing user:", error);
    toast.error("Something went wrong");
  } finally {
    setIsProcessingFollow(false);
  }
};


 // Add this function to calculate post scores - place it inside your Post component
// Updated function to calculate post score based on Appwrite likes array
const calculatePostScore = useCallback((post) => {
  // Now directly use comments from Appwrite instead of localStorage
  const commentsList = comments[post.id] || [];
  
  // Get the likes array from the post object
  const likesArray = post.likes || [];
  const likesCount = likesArray.length;
  
  // Use savedStates instead of localStorage for saved videos
  const savesCount = savedStates[post.id] ? 1 : 0;
  const commentsCount = commentsList.length;
  
  // Calculate recency score (newer posts get higher scores)
  const postDate = new Date(post.created_at);
  const now = new Date();
  const ageInHours = (now - postDate) / (1000 * 60 * 60);
  const recencyScore = Math.max(0, 100 - ageInHours); // Decreases with age
  
  // Calculate engagement score
  const engagementScore = (likesCount * 5) + (commentsCount * 10) + (savesCount * 15);
  
  return engagementScore + (recencyScore * 0.8);
}, [comments, savedStates]);

  // const getPersistentPostId = () => {
  //   const savedId = localStorage.getItem("post_uuid");
  //   if (savedId) return savedId;
  
  //   const newId = uuidv4();
  //   localStorage.setItem("post_uuid", newId);
  //   return newId;
  // };

  

  // Check localStorage for saved mute preference on component mount
  useEffect(() => {
    const savedMutePreference = localStorage.getItem("video_mute_preference");
    if (savedMutePreference !== null) {
      setGlobalMutePreference(savedMutePreference === "true");
    }
  }, []);

  const [posts, setPosts] = useState([]);
  const token = useSelector((state) => state.token);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  

  // Add this effect to fetch posts
  // useEffect(() => {
  //   const fetchPosts = async () => {
  //     try {
        
  //       const response = await fetch("http://localhost:3001/posts", {
  //         method: "GET",
  //         headers: { Authorization: `Bearer ${token}` },
  //       });
        
  //       if (!response.ok) {
  //         throw new Error("Failed to fetch posts");
  //       }
        
  //       const fetchedPosts = await response.json();
        
  //       // Map the backend post format to the format expected by your component
  //       const formattedPosts = fetchedPosts.map(post => ({
  //         id: post._id || uuidv4(),  // fallback to uuid if _id is missing
  //         profile: {
  //           user_id: post.userId,
  //           name: `${post.firstName} ${post.lastName}`,
  //           verified: false,
  //           image: post.userPicturePath 
  //             ? `http://localhost:3001/assets/${post.userPicturePath}` 
  //             : "https://via.placeholder.com/60",
  //         },
  //         text: post.description,
  //         hashtags: post.description ? post.description.match(/#\w+/g) || [] : [],
  //         video_url: post.videoPath
  //           ? `http://localhost:3001/assets/${post.videoPath}`
  //           : null,
  //         created_at: new Date(post.createdAt).toLocaleString(),
  //         talent: post.talent || "Unknown"
  //       }));
        
  //       // Sort posts by creation date (newest first)
  //       const sortedPosts = formattedPosts.sort((a, b) => {
  //         return new Date(b.created_at) - new Date(a.created_at);
  //       });
        
  //       // Include the sample videos if there are no posts or if you want to keep them
  //       const samplePosts = [
  //         // Sample posts code removed for brevity
  //       ];
        
  //       // Combine real posts with sample posts, keeping sorted posts at the top
  //       setPosts([...sortedPosts, ...samplePosts]);
        
  //     } catch (error) {
  //       console.error("Error fetching posts:", error);
  //     }
  //   };
    
  //   fetchPosts();
  // }, [token]);

  // Initialize video states for each post
  useEffect(() => {
    const initialStates = posts.reduce((acc, post) => {
      acc[post.id] = {
        playing: false,
        muted: globalMutePreference, // Use global preference
        isFullscreen: false, 
        progress: 0
      };
      return acc;
    }, {});
    
    setVideoStates(initialStates);
  }, [posts, globalMutePreference]);
  

  // const [comments, setComments] = useState([
  //   { user: "Alex", text: "Awesome video!" },
  //   { user: "Jamie", text: "Loved the vibes ✨" },
  // ]);
  
// Update the addComment function to include user information
// Replace the existing addComment function
// Update the addComment function in Post.jsx to properly create comment notifications

const addComment = async (postId, commentText) => {
  if (!currentUserId || !user) {
    toast.error("Please log in to comment");
    return;
  }

  // Get current user info from Redux store
  const currentUser = {
    userId: user._id,
    name: `${user.firstName} ${user.lastName}`,
    profilePicPath: user.picturePath || null
  };

  try {
    // Get post owner info first to create notification
    const postDoc = await databases.getDocument(
      DATABASE_ID,
      COLLECTION_ID,
      postId
    );

    const postOwnerId = postDoc.userId;

    // Create the new comment in Appwrite
    const newCommentData = {
      postId: postId,
      userId: currentUser.userId,
      userName: currentUser.name,
      text: commentText,
      userImage: currentUser.profilePicPath,
      createdAt: new Date().toISOString()
    };

    // Add to Appwrite
    const createdComment = await databases.createDocument(
      DATABASE_ID,
      COMMENTS_COLLECTION_ID,
      ID.unique(),
      newCommentData
    );

    // Create notification for post owner (if they're not the commenter)
    if (postOwnerId !== currentUser.userId) {
      await createNotification(
        postOwnerId, 
        currentUser.userId,
        currentUser.name,
        'comment',
        postId,
        commentText.substring(0, 50), // Include part of the comment text
        currentUser.profilePicPath // Add profile pic path for the notification
      );
    }

    // Format the comment for our UI
    const uiComment = {
      userId: createdComment.userId,
      user: createdComment.userName,
      text: createdComment.text,
      profilePic: createdComment.userImage ? 
        storage.getFileView(BUCKET_ID, createdComment.userImage) : 
        `https://i.pravatar.cc/150?u=${createdComment.userId}`,
      timestamp: createdComment.createdAt,
      isCurrentUser: true,
      commentId: createdComment.$id
    };

    // Update local state
    setComments(prevComments => {
      const updatedComments = {
        ...prevComments,
        [postId]: [...(prevComments[postId] || []), uiComment]
      };

      return updatedComments;
    });

    toast.success("Comment added!");
  } catch (error) {
    // console.error("Error adding comment:", error);
    toast.error("Failed to post comment");
  }
};
  
  // Initialize the active post to the first post and update URL
  useEffect(() => {
    if (posts.length > 0 && isInitialLoad) {
      const firstPostId = posts[0].id;
      setActivePostId(firstPostId);
      updateUrlWithPostId(firstPostId);
      setIsInitialLoad(false);
    }
  }, [posts, isInitialLoad]);
  
  // Fixed: Update URL with post ID without reloading the page
  const updateUrlWithPostId = (postId) => {
    if (!postId) return;
    
    // Force URL update regardless of current path
    navigate(`/home/post/${postId}`, { replace: true });
  };
  
// Update the handleOpenCommentModal function
const handleOpenCommentModal = (postId) => {
  navigate(`/home/post/${postId}/comments`, { replace: true });
  setOpenCommentModal(true);
  setActivePostId(postId); // Ensure we know which post's comments to show
};


  const handleCloseCommentModal = () => {
    // Revert URL back to the active post URL
    navigate(`/home/post/${activePostId || posts[0]?.id}`, { replace: true });
    setOpenCommentModal(false);
  };

  // Check URL on component mount to handle direct navigation
  useEffect(() => {
    // Extract post ID from URL if present
    const pathParts = location.pathname.split('/');
    const postIndex = pathParts.indexOf('post');
    
    if (postIndex !== -1 && pathParts[postIndex + 1]) {
      const urlPostId = pathParts[postIndex + 1];
      setActivePostId(urlPostId);
      
      // If URL contains comments path, open the modal
      if (pathParts.includes('comments')) {
        setOpenCommentModal(true);
      }
    }
  }, [location.pathname]);

  // Setup intersection observer to detect which post is in view
// Modify your useEffect that sets up the intersection observer
 // Add this filtering logic before rendering the posts
// Replace the existing filteredPosts memo with this enhanced version
const filteredPosts = useMemo(() => {
  // First filter by talent if needed
  const talentFiltered = selectedTalent === "All" 
    ? posts 
    : posts.filter(post => post.talent === selectedTalent);
  
  // Sort by the initial order we established
  if (initialPostOrder.length > 0) {
    return [...talentFiltered].sort((a, b) => {
      return initialPostOrder.indexOf(a.id) - initialPostOrder.indexOf(b.id);
    });
  }
  
  // Fallback to score-based sorting only for the initial load
  return [...talentFiltered].sort((a, b) => {
    const scoreA = calculatePostScore(a);
    const scoreB = calculatePostScore(b);
    return scoreB - scoreA;
  });
}, [posts, selectedTalent, initialPostOrder, calculatePostScore]);
useEffect(() => {
  if (filteredPosts.length === 0) return;  // Use filteredPosts instead of posts

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.6,
  };

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };
  
  const debouncedPlay = debounce((postId) => {
    const videoElement = videoRefs.current[postId];
    if (videoElement) {
      videoElement.muted = !userHasInteracted.current || globalMutePreference;
      const playPromise = videoElement.play();
  
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            setVideoStates(prev => ({
              ...prev,
              [postId]: {
                ...prev[postId],
                playing: true,
                muted: videoElement.muted,
              },
            }));
          })
          .catch((error) => {
            // console.error("Autoplay prevented:", error);
            videoElement.muted = true;
            videoElement.play().then(() => {
              setVideoStates(prev => ({
                ...prev,
                [postId]: {
                  ...prev[postId],
                  playing: true,
                  muted: true,
                },
              }));
            }).catch(err => console.error("Muted autoplay also failed:", err));
          });
      }
    }
  }, 200);

  const handleIntersect = (entries) => {
    entries.forEach(entry => {
      const postId = entry.target.dataset.postid;
      if (!postId) return;

      if (entry.isIntersecting) {
        setActivePostId(postId);
        updateUrlWithPostId(postId);
        debouncedPlay(postId);
      
        Object.keys(videoRefs.current).forEach(id => {
          if (id !== postId && videoRefs.current[id]) {
            videoRefs.current[id].pause();
            setVideoStates(prev => ({
              ...prev,
              [id]: { ...prev[id], playing: false },
            }));
          }
        });
      }
      else {
        if (postId === activePostId) {
          const videoElement = videoRefs.current[postId];
          if (videoElement) {
            videoElement.pause();
            setVideoStates(prev => ({
              ...prev,
              [postId]: { ...prev[postId], playing: false }
            }));
          }
        }
      }
    });
  };

  const observer = new IntersectionObserver(handleIntersect, observerOptions);
  
  // Disconnect previous observer first
  if (observer) {
    observer.disconnect();
  }

  // Then observe all filtered posts with a short delay
  setTimeout(() => {
    Object.keys(postsRefs.current).forEach(postId => {
      // Only observe posts that are in the filtered list
      const isInFilteredList = filteredPosts.some(post => post.id === postId);
      if (postsRefs.current[postId] && isInFilteredList) {
        observer.observe(postsRefs.current[postId]);
      }
    });
  }, 100);

  return () => {
    observer.disconnect();
  };
}, [filteredPosts, globalMutePreference, selectedTalent]); // Add selectedTalent as dependency  
  // Video playback controls - Now using postId to target specific videos
  const handlePlayPause = (postId) => {
    if (!videoRefs.current[postId]) return;
    
    const videoElement = videoRefs.current[postId];
    const isCurrentlyPlaying = videoStates[postId]?.playing || false;
    
    if (isCurrentlyPlaying) {
      videoElement.pause();
    } else {
      // If this is first interaction, we can try to unmute based on preference
      if (!userHasInteracted.current) {
        userHasInteracted.current = true;
        // Apply the current global mute preference
        videoElement.muted = globalMutePreference;
      }
      
      videoElement.play();
    }
    
    setVideoStates(prev => ({
      ...prev,
      [postId]: { 
        ...prev[postId], 
        playing: !isCurrentlyPlaying,
        muted: videoElement.muted
      }
    }));
  };

  const toggleMute = (postId, e) => {
    if (e) {
      e.stopPropagation(); // Prevent video pause/play when clicking mute button
    }
    
    if (!videoRefs.current[postId]) return;
    
    // Set user has interacted flag
    userHasInteracted.current = true;
    
    const videoElement = videoRefs.current[postId];
    const isCurrentlyMuted = videoElement.muted;
    
    // Toggle mute state for this video
    videoElement.muted = !isCurrentlyMuted;
    
    // Update the global preference for all videos
    setGlobalMutePreference(!isCurrentlyMuted);
    
    // Save preference to localStorage
    localStorage.setItem("video_mute_preference", (!isCurrentlyMuted).toString());
    
    // Apply to all visible videos
    Object.keys(videoRefs.current).forEach(id => {
      if (videoRefs.current[id]) {
        videoRefs.current[id].muted = !isCurrentlyMuted;
      }
    });
    
    // Update state for all videos
    setVideoStates(prev => {
      const newStates = {...prev};
      Object.keys(newStates).forEach(id => {
        newStates[id] = {...newStates[id], muted: !isCurrentlyMuted};
      });
      return newStates;
    });
  };

  const toggleFullscreen = (postId) => {
    if (!videoContainerRefs.current[postId]) return;
    
    const el = videoContainerRefs.current[postId];
    const isCurrentlyFullscreen = videoStates[postId]?.isFullscreen || false;
    
    if (!document.fullscreenElement) {
      el.requestFullscreen?.().then(() => {
        setVideoStates(prev => ({
          ...prev,
          [postId]: { ...prev[postId], isFullscreen: true }
        }));
      });
    } else {
      document.exitFullscreen?.().then(() => {
        setVideoStates(prev => ({
          ...prev,
          [postId]: { ...prev[postId], isFullscreen: false }
        }));
      });
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        // Reset all fullscreen states when exiting
        setVideoStates(prev => {
          const newStates = {...prev};
          Object.keys(newStates).forEach(id => {
            newStates[id] = {...newStates[id], isFullscreen: false};
          });
          return newStates;
        });
      }
    };
    
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  // Initialize post order once when posts are loaded
useEffect(() => {
  if (posts.length > 0 && initialPostOrder.length === 0) {
    // Sort posts initially by score
    const sorted = [...posts].sort((a, b) => {
      const scoreA = calculatePostScore(a);
      const scoreB = calculatePostScore(b);
      return scoreB - scoreA; // Higher scores first
    });
    
    // Save the IDs in their sorted order
    setInitialPostOrder(sorted.map(post => post.id));
  }
}, [posts, calculatePostScore]);

  // Update progress as video plays
  const handleTimeUpdate = (postId) => {
    if (!videoRefs.current[postId]) return;
    
    const current = videoRefs.current[postId].currentTime || 0;
    const duration = videoRefs.current[postId].duration || 1;
    const progress = (current / duration) * 100;
    
    setVideoStates(prev => ({
      ...prev,
      [postId]: { ...prev[postId], progress }
    }));
  };

  // Seek video when user clicks on the progress bar
  const handleProgressClick = (e, postId) => {
    if (!progressBarRefs.current[postId] || !videoRefs.current[postId]) return;
    
    // Mark user interaction when clicking progress bar
    userHasInteracted.current = true;
    
    const bar = progressBarRefs.current[postId];
    const videoElement = videoRefs.current[postId];
    
    const rect = bar.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const width = rect.width;

    const percentage = clickX / width;
    const newTime = videoElement.duration * percentage;
    videoElement.currentTime = newTime;
  };

    // Add this useEffect to check if a post is saved when the component loads
// Replace the useEffect for checking saved posts
// useEffect(() => {
//   if (posts.length > 0) {
//     const savedVideos = JSON.parse(localStorage.getItem('savedVideos') || '[]');
    
//     // Create a mapping of post IDs to their saved status
//     const newSavedStates = posts.reduce((acc, post) => {
//       // Check if this post is saved by the current user
//       const isPostSaved = savedVideos.some(
//         savedVideo => savedVideo.id === post.id && savedVideo.savedBy === currentUserId
//       );
//       acc[post.id] = isPostSaved;
//       return acc;
//     }, {});
    
//     setSavedStates(newSavedStates);
//   }
// }, [posts, currentUserId]);

// Update the handleSaveVideo function to update all saved states
const handleSaveVideo = async (post) => {
  if (!currentUserId) {
    // Show login prompt or redirect to login
    alert("Please login to save videos");
    return;
  }
  
  // Get current saved state
  const isCurrentlySaved = savedStates[post.id] || false;
  
  // Update UI immediately (optimistic update)
  setSavedStates(prev => ({
    ...prev,
    [post.id]: !isCurrentlySaved
  }));
  
  // Also update the active post's saved state if it's the current post
  if (post.id === activePostId) {
    setSaved(!isCurrentlySaved);
  }
  
  try {
    // Check if this post is already saved by this user
    const existingSaves = await databases.listDocuments(
      DATABASE_ID,
      SAVED_VIDEOS_COLLECTION_ID,
      [
        Query.equal('userId', currentUserId),
        Query.equal('postId', post.id)
      ]
    );
    
    if (existingSaves.documents.length === 0) {
      // Not saved yet, so save it
      await databases.createDocument(
        DATABASE_ID,
        SAVED_VIDEOS_COLLECTION_ID,
        ID.unique(),
        {
          userId: currentUserId,
          postId: post.id,
          postOwnerId: post.profile.user_id,
          savedAt: new Date().toISOString(),
          
            title: post.text || "Untitled Video",
            thumbnail: post.video_url,
            creator: post.profile.name,
            talent: post.talent || "Talent",
            userImage: post.profile.image,
            subtitle: post.profile.subtitle || post.text?.substring(0, 30) || "Video creator",
            // hashtags: post.hashtags || [],
          
        }
      );
      
      // Show success toast/notification
      toast.success("Video saved successfully!");
      
    } else {
      // Already saved, so unsave it
      const savedDocId = existingSaves.documents[0].$id;
      await databases.deleteDocument(
        DATABASE_ID,
        SAVED_VIDEOS_COLLECTION_ID,
        savedDocId
      );
      
      // Show success toast/notification
      toast.info("Video removed from saved collection");
    }
    
  } catch (error) {
    // console.error("Error saving/unsaving video:", error);
    toast.error("Failed to update saved status");
    
    // Revert the UI update on error
    setSavedStates(prev => ({
      ...prev,
      [post.id]: isCurrentlySaved
    }));
    
    if (post.id === activePostId) {
      setSaved(isCurrentlySaved);
    }
  }
};

// Add this function to handle liking/unliking videos
// Replace the handleLikeVideo function with this version
// Modified handleLikeVideo function to add notifications
// Debugged version of handleLikeVideo function
const handleLikeVideo = async (post) => {
  if (!currentUserId) {
    alert("Please login to like videos");
    return;
  }

  // console.log("Like button clicked for post:", post.id);
  // console.log("Current user ID:", currentUserId);
  // console.log("Post owner ID:", post.profile.user_id);

  // Get current liked state
  const isCurrentlyLiked = likedStates[post.id] || false;
  // console.log("Is currently liked:", isCurrentlyLiked);

  // Update UI immediately (optimistic update)
  setLikedStates(prev => ({ ...prev, [post.id]: !isCurrentlyLiked }));

  // Also update the active post's liked state if it's the current post
  if (post.id === activePostId) {
    setLiked(!isCurrentlyLiked);
  }

  try {
    // Get the current post document from Appwrite
    const postDoc = await databases.getDocument(
      DATABASE_ID,
      COLLECTION_ID,
      post.id
    );
    // console.log("Retrieved post document:", postDoc);

    // Get the current likes array or initialize it if it doesn't exist
    const currentLikes = postDoc.likes || [];
    let updatedLikes;

    if (isCurrentlyLiked) {
      // User already liked the post, so remove their ID
      updatedLikes = currentLikes.filter(userId => userId !== currentUserId);
      // console.log("Removing like - updated likes:", updatedLikes);
    } else {
      // User hasn't liked the post, so add their ID
      updatedLikes = [...currentLikes, currentUserId];
      // console.log("Adding like - updated likes:", updatedLikes);
      
      // Only send notification if this is a new like (not an unlike)
      // and if the post is not the current user's own post
// Updated handleLikeVideo function - focusing on the notification creation part
// Inside handleLikeVideo function in Post.jsx:

// Near the part where you create the notification:
if (post.profile.user_id !== currentUserId) {
  // console.log("Attempting to create notification for user:", post.profile.user_id);
  
  try {
    // Create a notification for the post owner using direct Appwrite call
    const notificationData = {
      receiverId: post.profile.user_id,                 // receiverId (post owner)
      senderId: currentUserId,                          // senderId (current user)
      senderName: `${user.firstName} ${user.lastName}`, // senderName
      senderPicturePath: user.picturePath,              // Include sender's profile picture
      type: 'like',                                     // type
      postId: post.id,                                  // postId
      content: 'liked your post',                       // content
      isRead: false,  
      createdAt: new Date().toISOString()
    };
    
    // console.log("Creating notification with data:", notificationData);
    
    const notificationResult = await databases.createDocument(
      DATABASE_ID,
      NOTIFICATION_ID,
      ID.unique(),
      notificationData
    );
    
    // console.log("Notification created successfully:", notificationResult);
  } catch (notifError) {
    // console.error("Error creating notification:", notifError);
  }
} else {
        // console.log("No notification created - user liked their own post");
      }
    }

    // Update the post document with the new likes array
    await databases.updateDocument(
      DATABASE_ID,
      COLLECTION_ID,
      post.id,
      { likes: updatedLikes }
    );
    // console.log("Post updated with new likes array");

    // Update posts state with the new likes count
    setPosts(prevPosts => prevPosts.map(p => {
      if (p.id === post.id) {
        return {
          ...p,
          likes: updatedLikes // Update the likes array in the post
        };
      }
      return p;
    }));

  } catch (error) {
    // console.error("Error liking/unliking video:", error);
    toast.error("Failed to update like status");

    // Revert the UI update on error
    setLikedStates(prev => ({ ...prev, [post.id]: isCurrentlyLiked }));

    if (post.id === activePostId) {
      setLiked(isCurrentlyLiked);
    }
  }
};
// Replace the useEffect for checking liked videos with this version
useEffect(() => {
  const fetchLikedStates = async () => {
    if (!currentUserId || posts.length === 0) return;
    
    try {
      // Create a mapping of post IDs to their liked status
      const newLikedStates = {};
      
      for (const post of posts) {
        try {
          // Get the post document from Appwrite
          const postDoc = await databases.getDocument(
            DATABASE_ID,
            COLLECTION_ID,
            post.id
          );
          
          // Check if current user's ID is in the likes array
          const likes = postDoc.likes || [];
          newLikedStates[post.id] = likes.includes(currentUserId);
        } catch (err) {
          // console.error(`Error fetching likes for post ${post.id}:`, err);
          newLikedStates[post.id] = false;
        }
      }
      
      setLikedStates(newLikedStates);
      
    } catch (error) {
      // console.error("Error fetching liked videos state:", error);
    }
  };
  
  fetchLikedStates();
}, [posts, currentUserId]);

useEffect(() => {
  const fetchSavedStates = async () => {
    if (!currentUserId || posts.length === 0) return;
    
    try {
      // Fetch all saved videos by current user
      const response = await databases.listDocuments(
        DATABASE_ID,
        SAVED_VIDEOS_COLLECTION_ID,
        [Query.equal('userId', currentUserId)]
      );
      
      // Create a set of saved post IDs for quick lookup
      const savedPostIds = new Set(
        response.documents.map(doc => doc.postId)
      );
      
      // Create a mapping of post IDs to their saved status
      const newSavedStates = posts.reduce((acc, post) => {
        acc[post.id] = savedPostIds.has(post.id);
        return acc;
      }, {});
      
      setSavedStates(newSavedStates);
      
    } catch (error) {
      // console.error("Error fetching saved videos state:", error);
    }
  };
  
  fetchSavedStates();
}, [posts, currentUserId]);
// Add this useEffect to check if posts are liked when the component loads


// useEffect(() => {
//   if (posts.length > 0) {
//     const likedVideos = JSON.parse(localStorage.getItem('likedVideos') || '[]');
    
//     // Create a mapping of post IDs to their liked status
//     const newLikedStates = posts.reduce((acc, post) => {
//       // Check if this post is liked by the current user
//       const isPostLiked = likedVideos.some(
//         likedVideo => likedVideo.postId === post.id && likedVideo.likedBy === currentUserId
//       );
//       acc[post.id] = isPostLiked;
//       return acc;
//     }, {});
    
//     setLikedStates(newLikedStates);
//   }
// }, [posts, currentUserId]);




// Add this useEffect to initialize comments from localStorage
// Replace the existing comments loading with this
// Replace the comments loading useEffect in Post.jsx
useEffect(() => {
  const loadComments = async () => {
    if (!posts.length) return;
    
    try {
      // Fetch all comments for all posts with proper ordering
      const response = await databases.listDocuments(
        DATABASE_ID,
        COMMENTS_COLLECTION_ID,
        [Query.orderDesc('createdAt')] // Order by creation time (newest first)
      );
      
      // Group comments by postId
      const commentsByPost = {};
      
      // Process each comment from Appwrite
      response.documents.forEach(comment => {
        if (!commentsByPost[comment.postId]) {
          commentsByPost[comment.postId] = [];
        }
        
        // Format the comment for our UI
        const uiComment = {
          _id: comment.$id, // Store Appwrite document ID
          userId: comment.userId,
          user: comment.userName,
          text: comment.text,
          profilePic: comment.userImage ? 
            storage.getFileView(BUCKET_ID, comment.userImage) : 
            `https://i.pravatar.cc/150?u=${comment.userId}`,
          timestamp: comment.createdAt,
          isCurrentUser: comment.userId === currentUserId,
          commentId: comment.$id // Store the comment ID for potential updates/deletion
        };
        
        commentsByPost[comment.postId].push(uiComment);
      });
      
      // Update state with all fetched comments
      setComments(commentsByPost);
      
      // console.log("Comments loaded:", commentsByPost);
    } catch (error) {
      // console.error("Error fetching comments:", error);
    }
  };
  
  loadComments();
}, [posts, currentUserId]);

// Update your useEffect
useEffect(() => {
  const loadPosts = async () => {
    // First try to get posts from Appwrite
    const appwritePosts = await fetchPostsFromAppwrite();
    
    if (appwritePosts.length > 0) {
      setPosts(appwritePosts);
      
      // Initialize video states for the new posts
      const initialVideoStates = {};
      appwritePosts.forEach(post => {
        initialVideoStates[post.id] = {
          playing: false,
          muted: true,
          progress: 0,
          isFullscreen: false,
        };
      });
      setVideoStates(initialVideoStates);
    } else if (!appwriteError) {
      // Only log if it's not an error case
      // console.log("No posts found in Appwrite, using fallback data if available");
    }
  };
  
  loadPosts();
}, []);

// Add a retry function
const retryFetchPosts = async () => {
  const appwritePosts = await fetchPostsFromAppwrite();
  
  if (appwritePosts.length > 0) {
    setPosts(appwritePosts);
    
    // Initialize video states for the new posts
    const initialVideoStates = {};
    appwritePosts.forEach(post => {
      initialVideoStates[post.id] = {
        playing: false,
        muted: true,
        progress: 0,
        isFullscreen: false,
      };
    });
    setVideoStates(initialVideoStates);
  }
};


// Add this function to handle sharing a post link
// Improved share post function
const handleSharePost = (postId) => {
  // Create a more direct URL structure
  const postUrl = `${window.location.origin}/home/post/${postId}?source=shared`;
  
 // Check if it's an actual mobile device (not just small screen)
  const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  
  // Copy to clipboard
  navigator.clipboard.writeText(postUrl)
    .then(() => {
      // Show feedback only if NOT on actual mobile devices
      if (!isMobileDevice) {
        const feedbackEl = document.createElement('div');
        feedbackEl.textContent = 'Link copied!';
        feedbackEl.style = `
          position: fixed;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          background: rgba(0,0,0,0.8);
          color: white;
          padding: 12px 24px;
          border-radius: 8px;
          z-index: 9999;
          font-size: 16px;
        `;
        document.body.appendChild(feedbackEl);
        setTimeout(() => {
          if (document.body.contains(feedbackEl)) {
            document.body.removeChild(feedbackEl);
          }
        }, 2000);
      }
    })
    .catch(err => {
      // Fallback for older browsers
      console.error("Copy failed", err);
      const textArea = document.createElement('textarea');
      textArea.value = postUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      
      // Show feedback for fallback (regardless of device)
      alert("Link copied to clipboard!");
    });};
    
useEffect(() => {
  // Check if we need to open comment modal based on URL
  const pathSegments = location.pathname.split('/');
  if (pathSegments.includes('comments')) {
    const postIdIndex = pathSegments.indexOf('post') + 1;
    if (postIdIndex > 0 && postIdIndex < pathSegments.length) {
      const postIdFromURL = pathSegments[postIdIndex];
      // Set active post id and open comment modal
      setActivePostId(postIdFromURL);
      setOpenCommentModal(true);
    }
  }
}, [location.pathname]);

// Update this useEffect to scroll to the specific post when a URL with postId is visited
// Enhanced URL handling with better scrolling behavior
useEffect(() => {
  // Extract post ID from URL if present
  const pathParts = location.pathname.split('/');
  const postIndex = pathParts.indexOf('post');
  const urlParams = new URLSearchParams(location.search);
  const isShared = urlParams.get('source') === 'shared';
  
  if (postIndex !== -1 && pathParts[postIndex + 1]) {
    const urlPostId = pathParts[postIndex + 1];
    
    // Set active post ID
    setActivePostId(urlPostId);
    
    // Handle comments if in URL
    if (pathParts.includes('comments')) {
      setOpenCommentModal(true);
    }
    
    // Improved scroll handling with multiple attempts
    const scrollToPost = (attempt = 0) => {
      if (attempt > 10) return; // Give up after several attempts
      
      const postElement = postsRefs.current[urlPostId];
      if (postElement) {
        // Force layout recalculation
        postElement.getBoundingClientRect();
        
        // Use more direct scrolling for shared links
        if (isShared) {
          // First scroll to approximate position
          const container = containerRef.current;
          const parentRect = container.getBoundingClientRect();
          const postRect = postElement.getBoundingClientRect();
          const offset = postRect.top - parentRect.top;
          
          // Use more direct scrolling method
          container.scrollTo({
            top: offset - 100, // Adjust offset to account for headers
            behavior: 'auto' // Use 'auto' for immediate scroll
          });
          
          // After a small delay, ensure exact position
          setTimeout(() => {
            postElement.scrollIntoView({
              block: 'center',
              behavior: 'auto'
            });
            
            // Add a visual indicator for the shared post
            postElement.style.boxShadow = '0 0 20px rgba(240, 44, 86, 0.8)';
            setTimeout(() => {
              postElement.style.boxShadow = '';
            }, 3000);
          }, 100);
        } else {
          // Standard smooth scrolling for normal navigation
          postElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      } else {
        // Post element not found yet, retry after a short delay
        setTimeout(() => scrollToPost(attempt + 1), 200);
      }
    };
    
    // Start scrolling process with a small initial delay
    setTimeout(() => scrollToPost(), 100);
  }
}, [location.pathname, location.search, posts.length]);

// Replace the localStorage-based useEffect with this Appwrite implementation
useEffect(() => {
  if (posts.length > 0 && currentUserId) {
    // Fetch all follow relationships for the current user in one call
    const fetchFollowStatuses = async () => {
      try {
        // Check followed users
        const followedResponse = await databases.listDocuments(
          DATABASE_ID,
          FOLLOWERS_COLLECTION_ID,
          [Query.equal('followerId', currentUserId)]
        );

        // Create a mapping of user IDs to their followed status
        const newFollowedStates = posts.reduce((acc, post) => {
          // Check if this user is followed by the current user
          const isUserFollowed = followedResponse.documents.some(
            doc => doc.followedId === post.profile.user_id
          );
          acc[post.profile.user_id] = isUserFollowed;
          return acc;
        }, {});

        setFollowedStates(newFollowedStates);

        // Check pending requests
        const pendingResponse = await databases.listDocuments(
          DATABASE_ID,
          FOLLOW_REQUESTS_COLLECTION_ID,
          [
            Query.equal('requesterId', currentUserId),
            Query.equal('status', 'pending')
          ]
        );

        // Create a mapping of user IDs to their pending request status
        const newPendingStates = posts.reduce((acc, post) => {
          const isRequestPending = pendingResponse.documents.some(
            doc => doc.userId === post.profile.user_id
          );
          // Don't mark as pending if already followed
          acc[post.profile.user_id] = isRequestPending && !newFollowedStates[post.profile.user_id];
          return acc;
        }, {});

        setPendingRequests(newPendingStates);
      } catch (error) {
        // console.error("Error fetching follow statuses from Appwrite:", error);
      }
    };

    fetchFollowStatuses();
  }
}, [posts, currentUserId]);

  // Add a function to handle talent selection
  const handleTalentChange = (event) => {
    setSelectedTalent(event.target.value);
  };
  
// Add this function to automatically refresh the post list periodically

// useEffect(() => {
//   let refreshInterval;
  
//   const autoRefreshPosts = async () => {
//     try {
//       // Keep the main Appwrite fetch logic instead
//       const appwritePosts = await fetchPostsFromAppwrite();
      
//       if (appwritePosts.length > 0) {
//         // Update posts without disrupting user experience
//         setPosts(prev => {
//           // Identify new posts
//           const newPostIds = appwritePosts.map(p => p.id);
//           const existingPostIds = prev.map(p => p.id);
          
//           // Find truly new posts
//           const brandNewPosts = appwritePosts.filter(p => !existingPostIds.includes(p.id));
          
//           if (brandNewPosts.length > 0) {
//             // Initialize video states for new posts
//             const initialVideoStates = {};
//             brandNewPosts.forEach(post => {
//               initialVideoStates[post.id] = {
//                 playing: false,
//                 muted: true,
//                 progress: 0,
//                 isFullscreen: false,
//               };
//             });
            
//             // Add new video states
//             setVideoStates(prev => ({
//               ...prev,
//               ...initialVideoStates
//             }));
            
//             // Only append new posts, preserving existing post states
//             return [...prev, ...brandNewPosts];
//           }
//           return prev;
//         });
//       }
//     } catch (error) {
//       console.error("Error auto-refreshing posts:", error);
//     }
//   };
  
//   // Set refresh interval (every 60 seconds)
//   refreshInterval = setInterval(autoRefreshPosts, 60000);
  
//   return () => {
//     clearInterval(refreshInterval);
//   };
// }, []);  // Remove token dependency if you're not using it with Appwrite
// Add this effect to load pending requests on component mount
// Update this effect to verify pending requests against actual follow status


// useEffect(() => {
//   if (posts.length > 0 && currentUserId) {
//     // Load followed states
//     const followedUsers = JSON.parse(localStorage.getItem('followedUsers') || '[]');
//     const newFollowedStates = posts.reduce((acc, post) => {
//       const isUserFollowed = followedUsers.some(
//         followData => followData.followedId === post.profile.user_id && followData.followerId === currentUserId
//       );
//       acc[post.profile.user_id] = isUserFollowed;
//       return acc;
//     }, {});
//     setFollowedStates(newFollowedStates);
    
//     // Load pending requests
//     const pendingRequests = JSON.parse(localStorage.getItem('pendingFollowRequests') || '[]');
//     const newPendingStates = posts.reduce((acc, post) => {
//       const isRequestPending = pendingRequests.some(
//         reqData => reqData.userId === post.profile.user_id && reqData.requesterId === currentUserId
//       );
//       // Don't mark as pending if already followed
//       acc[post.profile.user_id] = isRequestPending && !newFollowedStates[post.profile.user_id];
//       return acc;
//     }, {});
//     setPendingRequests(newPendingStates);
    
//     // Verify current status of pending requests
//     setTimeout(() => {
//       Object.keys(newPendingStates).forEach(userId => {
//         if (newPendingStates[userId]) {
//           checkFollowStatus(userId);
//         }
//       });
//     }, 1000);
//   }
// }, [posts, currentUserId]);

// Add this useEffect to check follow status when posts load and periodically
useEffect(() => {
  // Skip if no posts or no user logged in
  if (!posts.length || !currentUserId || !token) return;
  
  // Check follow status for all users with pending requests
  const checkAllPendingFollows = async () => {
    const userIdsToCheck = Object.keys(pendingRequests).filter(id => pendingRequests[id]);
    
    for (const userId of userIdsToCheck) {
      await checkFollowStatus(userId);
    }
  };
  
  // Run on component mount
  checkAllPendingFollows();
  
  // Also run periodically (every 60 seconds)
  const intervalId = setInterval(checkAllPendingFollows, 60000);
  
  return () => clearInterval(intervalId);
}, [posts, pendingRequests, currentUserId, token]);

// Add this function to your Post component
const deleteComment = async (postId, commentId) => {
  if (!currentUserId) {
    toast.error("You must be logged in to delete comments");
    return;
  }
  
  try {
    // Delete the comment from Appwrite
    await databases.deleteDocument(
      DATABASE_ID,
      COMMENTS_COLLECTION_ID,
      commentId
    );
    
    // Update local state
    setComments(prevComments => {
      const updatedComments = { ...prevComments };
      
      if (updatedComments[postId]) {
        updatedComments[postId] = updatedComments[postId].filter(
          comment => comment.commentId !== commentId
        );
      }
      
      return updatedComments;
    });
    
    toast.success("Comment deleted successfully");
  } catch (error) {
    // console.error("Error deleting comment:", error);
    toast.error("Failed to delete comment");
  }
};
return (
  <Box
    ref={containerRef}
    sx={{
      width: "100%",
      display: "flex",
      justifyContent: "center",
      py: 2,
      bgcolor: "#FFFFFF",
      minHeight: "100vh",
      flexDirection: "column",
      alignItems: "center",
      gap: { xs: 2, sm: 3, md: 4 },
      overflow: "auto",
    }}
  >
    {/* Loading State */}
    {isLoading && (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "60vh",
          gap: 3
        }}
      >
        <CircularProgress 
          size={50} 
          sx={{ 
            color: "#F02C56" 
          }} 
        />
        <Typography 
          variant="h6" 
          sx={{ 
            color: "#666", 
            fontWeight: 500,
            textAlign: "center" 
          }}
        >
          Loading amazing content...
        </Typography>
      </Box>
    )}

    {/* Error State - Appwrite Connection Issues */}
    {!isLoading && appwriteError && filteredPosts.length === 0 && (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "60vh",
          gap: 3,
          textAlign: "center",
          px: 3
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            backgroundColor: "rgba(240, 44, 86, 0.1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 2
          }}
        >
          <Typography
            sx={{
              fontSize: "2rem",
              color: "#F02C56"
            }}
          >
            📡
          </Typography>
        </Box>
        
        <Typography 
          variant="h5" 
          sx={{ 
            color: "#333", 
            fontWeight: 600,
            mb: 1
          }}
        >
          Connection Issue
        </Typography>
        
        <Typography 
          variant="body1" 
          sx={{ 
            color: "#666", 
            maxWidth: 400,
            lineHeight: 1.6,
            mb: 2
          }}
        >
          We're experiencing some technical difficulties connecting to our servers. 
          Don't worry, we're working on it!
        </Typography>
        
        <Typography 
          variant="body2" 
          sx={{ 
            color: "#999", 
            maxWidth: 350,
            mb: 3
          }}
        >
          Once the connection is restored, all the amazing content will be visible here.
        </Typography>

        <Button
          onClick={retryFetchPosts}
          variant="contained"
          sx={{
            background: "linear-gradient(135deg, #F02C56 0%, #FF6A88 100%)",
            color: "white",
            fontWeight: 600,
            px: 4,
            py: 1.5,
            borderRadius: "25px",
            textTransform: "none",
            boxShadow: "none",
            // "&:hover": {
            //   background: "linear-gradient(135deg, #e81e4d 0%, #ff4d6d 100%)",
            //   boxShadow: "0 6px 20px rgba(240, 44, 86, 0.4)",
            // }
          }}
          startIcon={<RefreshIcon />}
        >
          Try Again
        </Button>
      </Box>
    )}

    {/* Empty State - No Posts Available */}
    {!isLoading && !appwriteError && filteredPosts.length === 0 && (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "60vh",
          gap: 3,
          textAlign: "center",
          px: 3
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            backgroundColor: "rgba(33, 150, 243, 0.1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 2
          }}
        >
          <Typography
            sx={{
              fontSize: "2rem",
              color: "#2196F3"
            }}
          >
            🎬
          </Typography>
        </Box>
        
        <Typography 
          variant="h5" 
          sx={{ 
            color: "#333", 
            fontWeight: 600,
            mb: 1
          }}
        >
          No Content Yet
        </Typography>
        
        <Typography 
          variant="body1" 
          sx={{ 
            color: "#666", 
            maxWidth: 400,
            lineHeight: 1.6
          }}
        >
          Looks like there are no posts available right now. 
          Be the first to share your amazing talent!
        </Typography>
      </Box>
    )}

    {/* Posts Content - Only show when we have posts */}
    {!isLoading && filteredPosts.length > 0 && (
      <>
        {filteredPosts.map((post) => (
          <Box
            key={post.id}
            ref={el => postsRefs.current[post.id] = el}
            data-postid={post.id}
            sx={{
              bgcolor: "white",
              boxShadow: 3,
              borderRadius: 3,
              width: {
                xs: "370px",
                sm: "460px",
                md: "460px"
              },
              p: { xs: 1.5, sm: 2 },
              position: "relative",
              border: activePostId === post.id ? "2px solid #F02C56" : "2px solid transparent",
              transform: "scale(0.9)",
              transformOrigin: "center top",
              mb: { xs: -1, sm: -2 },
              marginLeft: { 
                xs: "-10%",
                sm: "0%",
                md: "0%"
              },
              marginRight:{
                xs: "-3%",
              },
            }}
          >
            {/* ALL YOUR EXISTING POST CONTENT FROM paste-2.txt GOES HERE */}
            {/* This includes: */}
            {/* - "Your Creation" chip */}
            {/* - Header with profile image and user info */}
            {/* - Follow button */}
            {/* - Video section with all controls */}
            {/* - Interaction buttons (like, comment, share, save) */}
            
            {isOwnVideo(post) && (
              <Box
                sx={{
                  position: "absolute",
                  top: -12,
                  left: 20,
                  zIndex: 2,
                }}
              >
                <Chip
                  icon={<StarRounded />}
                  label="Your Creation"
                  size="small"
                  sx={{
                    bgcolor: "#8B5CF6",
                    color: "white",
                    fontWeight: "bold",
                    boxShadow: "0 4px 8px rgba(139, 92, 246, 0.3)",
                    "& .MuiChip-icon": {
                      color: "#FFD700"
                    }
                  }}
                />
              </Box>
            )}
            
            {/* Header */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <Box sx={{ display: "flex", gap: 1.5 }}>
                <Box
                  component="img"
                  src={post.profile.image}
                  alt="Profile"
                  sx={{
                    width: { xs: 40, sm: 45 },
                    height: { xs: 40, sm: 45 },
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "2px solid #ddd",
                  }}
                />
                <Box>
                  <Link 
                    to={`/profile/${post.profile.user_id}`} 
                    style={{ textDecoration: "none" }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 600, color: "#1a1a1a", fontSize: { xs: 13, sm: 14 }, marginBottom: 0.5 }}
                    >
                      {post.profile.name}
                    </Typography>
                  </Link>
                  <Typography 
                    sx={{ 
                      fontSize: { xs: 13, sm: 14 }, 
                      color: "#333", 
                      mt: 0.5, 
                      marginBottom: 0.5,
                      whiteSpace: "normal",
                      overflow: "visible",
                      textOverflow: "clip",
                      maxWidth: "100%", 
                      wordBreak: "break-word",
                      display: "block"
                    }}
                  >
                    {post.text}
                  </Typography>
                  <Box sx={{ fontSize: { xs: 11, sm: 12 }, color: "#2196f3", mt: 0.5 }}>
                    {post.hashtags.map((tag, i) => (
                      <span key={i} style={{ marginRight: 6, cursor: "pointer" }}>
                        {tag}
                      </span>
                    ))}
                  </Box>
                  
                  {/* Add talent info here */}
                  <Box sx={{ display: "flex", alignItems: "center", mt: 0.5, mb: 0.5 }}>
                    <Typography 
                      sx={{ 
                        fontSize: { xs: 11, sm: 12 },
                        color: "#2196f3", 
                        fontWeight: "bold",
                        bgcolor: "rgba(33, 150, 243, 0.1)",
                        px: 1,
                        py: 0.5,
                        borderRadius: 1
                      }}
                    >
                      {post.talent || "Talent"}
                    </Typography>
                  </Box>
                  
                  <Typography sx={{ fontSize: { xs: 9, sm: 10 }, color: "#aaa", mt: 0.5 }}>{post.created_at}</Typography>
                </Box>
              </Box>

              {post.profile.user_id !== currentUserId && (
                <Button
                  variant="contained"
                  onClick={() => handleFollowUser(post.profile.user_id)}
                  startIcon={
                    pendingRequests[post.profile.user_id] ? 
                      <FaUserClock /> : 
                      followedStates[post.profile.user_id] ? 
                        <FaUserCheck /> : 
                        <FaUserPlus />
                  }
                  sx={{
                    fontSize: { xs: 11, sm: 12 },
                    fontWeight: 600,
                    boxShadow: "none",
                    textTransform: "none",
                    background: pendingRequests[post.profile.user_id] ? 
                      "linear-gradient(135deg, #FFA726 0%, #FFB74D 100%)" : 
                      "linear-gradient(135deg, #F02C56 0%, #FF6A88 100%)",
                    color: "#fff",
                    borderRadius: "999px",
                    px: { xs: 1.5, sm: 2 },
                    py: 0.6,
                    "&:hover": {
                      background: pendingRequests[post.profile.user_id] ? 
                        "linear-gradient(135deg, #FB8C00 0%, #FFA726 100%)" : 
                        "linear-gradient(135deg, #e81e4d 0%, #ff4d6d 100%)",
                      boxShadow: "none",
                    },
                    perspective: 1000,
                  }}
                >
                  <motion.div
                    key={
                      pendingRequests[post.profile.user_id] ? 
                        "Pending" : 
                        followedStates[post.profile.user_id] ? 
                          "Following" : 
                          "Follow"
                    }
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.8, opacity: 0 }}
                    transition={{ type: "spring", stiffness: 500, damping: 25 }}
                  >
                    {pendingRequests[post.profile.user_id] ? 
                      "Request Sent" : 
                      followedStates[post.profile.user_id] ? 
                        "Following" : 
                        "Follow"}
                  </motion.div>
                </Button>
              )}
            </Box>

            {/* Video Section - Modified for YouTube Shorts-like appearance and smaller size */}
            <Box
              ref={el => videoContainerRefs.current[post.id] = el}
              sx={{ 
                mt: 2,
                position: "relative", 
                display: "flex", 
                flexDirection: "column",
                alignItems: "center",
                width: "100%"
              }}
            >
              <Box
                sx={{
                  width: {
                    xs: "100%",
                    sm: "420px",
                    md: "420px"
                  },
                  height: {
                    xs: "530px",
                    sm: "530px",
                    md: "530px"
                  },
                  mx: "auto",
                  borderRadius: 3,
                  overflow: "hidden",
                  background: "#000",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  position: "relative",
                }}
              >
                <video
                  ref={el => videoRefs.current[post.id] = el}
                  onClick={() => handlePlayPause(post.id)}
                  onPlay={() => setVideoStates(prev => ({
                    ...prev,
                    [post.id]: { ...prev[post.id], playing: true }
                  }))}
                  onPause={() => setVideoStates(prev => ({
                    ...prev,
                    [post.id]: { ...prev[post.id], playing: false }
                  }))}
                  onTimeUpdate={() => handleTimeUpdate(post.id)}
                  src={post.video_url}
                  muted={videoStates[post.id]?.muted}
                  playsInline
                  loop
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    cursor: "pointer",
                  }}
                />

                {/* Play Button */}
                {(!videoStates[post.id]?.playing) && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      borderRadius: "50%",
                      padding: 0,
                      cursor: "pointer",
                      animation: "pulse 1.8s infinite",
                    }}
                    onClick={() => handlePlayPause(post.id)}
                  >
                    <AiOutlinePlayCircle size={40} color="#fff" />
                  </Box>
                )}

                {/* "Tap for sound" overlay */}
                <Box
                  sx={{
                    position: "absolute",
                    top: 8,
                    left: 8,
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    borderRadius: 2,
                    padding: "4px 10px",
                    color: "white",
                    fontSize: { xs: 11, sm: 12 },
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    zIndex: 10,
                    transition: "opacity 0.3s ease-in-out",
                    opacity: (videoStates[post.id]?.muted) ? 1 : 0,
                    pointerEvents: (videoStates[post.id]?.muted) ? 'auto' : 'none',
                  }}
                  onClick={(e) => toggleMute(post.id, e)}
                >
                  <IoVolumeMute size={16} color="#fff" />
                  Tap for sound
                </Box>

                {/* Mute Button */}
                <Box
                  onClick={(e) => toggleMute(post.id, e)}
                  sx={{
                    position: "absolute",
                    bottom: 10,
                    left: 10,
                    width: { xs: 28, sm: 32 },
                    height: { xs: 28, sm: 32 },
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "rgba(0, 0, 0, 0.7)",
                    },
                  }}
                >
                  {videoStates[post.id]?.muted ? 
                    <IoVolumeMute size={18} color="#fff" /> : 
                    <IoVolumeHigh size={18} color="#fff" />
                  }
                </Box>

                {/* Progress Bar */}
                <Box
                  ref={el => progressBarRefs.current[post.id] = el}
                  onClick={(e) => handleProgressClick(e, post.id)}
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: { xs: 4, sm: 6 },
                    cursor: "pointer",
                    backgroundColor: "rgba(255,255,255,0.3)",
                  }}
                >
                  <Box
                    sx={{
                      height: "100%",
                      width: `${videoStates[post.id]?.progress || 0}%`,
                      background: "linear-gradient(to right, #F02C56, #FF6A88)",
                      transition: "width 0.2s ease",
                      borderRadius: "0 4px 4px 0",
                    }}
                  />
                </Box>
              </Box>
              
              {/* Video interaction buttons - MODIFIED TO STAY ON RIGHT SIDE ON ALL SCREENS */}
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  right: { xs: -40, sm: -50 },
                  transform: "translateY(-50%)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 2,
                  zIndex: 5,
                }}
              >
                {/* Like button */}
                <Tooltip title="Like" arrow>
                  <motion.div whileTap={{ scale: 1.2 }}>
                    <Box
                      onClick={() => handleLikeVideo(post)}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        color: likedStates[post.id] ? "#F02C56" : "#333",
                        cursor: "pointer",
                        "&:hover": { color: likedStates[post.id] ? "#ec407a" : "#666" },
                      }}
                    >
                      {likedStates[post.id] ? <AiFillHeart size={22} /> : <AiOutlineHeart size={22} />}
                      <Typography sx={{ fontSize: { xs: 10, sm: 11 } }}>
                        {post.total_likes || post.likes?.length || 0}
                      </Typography>
                    </Box>
                  </motion.div>
                </Tooltip>
                
                {/* Comment button */}
                <Tooltip title="Comment" arrow>
                  <motion.div whileTap={{ scale: 1.2 }}>
                    <Box
                      onClick={() => handleOpenCommentModal(post.id)}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        color: "#333",
                        cursor: "pointer",
                        "&:hover": { color: "#2196f3" },
                      }}
                    >
                      <FaRegComment />
                      <Typography variant="caption" sx={{ mt: 0.5 }}>
                        {comments[post.id] ? comments[post.id].length : 0}
                      </Typography>
                    </Box>
                  </motion.div>
                </Tooltip>

                {/* Share button */}
                <Tooltip title="Share" arrow>
                  <motion.div whileTap={{ scale: 1.2 }}>
                    <Box
                      onClick={() => handleSharePost(post.id)}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        color: "#333",
                        cursor: "pointer",
                        "&:hover": { color: "#555" },
                      }}
                    >
                      <AiOutlineShareAlt size={20} />
                      <Typography sx={{ fontSize: { xs: 10, sm: 11 } }}>Share</Typography>
                    </Box>
                  </motion.div>
                </Tooltip>

                {/* Save button */}
                <Tooltip title="Save" arrow>
                  <motion.div whileTap={{ scale: 1.2 }}>
                    <Box
                      onClick={() => handleSaveVideo(post)}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        color: savedStates[post.id] ? "#2196f3" : "#333",
                        cursor: "pointer",
                        "&:hover": { color: savedStates[post.id] ? "#1976d2" : "#555" },
                      }}
                    >
                      {savedStates[post.id] ? <BsBookmarkFill size={18} /> : <BsBookmark size={18} />}
                    </Box>
                  </motion.div>
                </Tooltip>
              </Box>
            </Box>
          </Box>
        ))}
      </>
    )}
    
    {/* Comment Overlay Component */}
    <CommentOverlay
      open={openCommentModal}
      onClose={handleCloseCommentModal}
      postId={activePostId}
      comments={comments[activePostId] || []}
      addComment={addComment}
      deleteComment={deleteComment}
    />
  </Box>
);}
